import { Analytics } from '@workivate/tho-web-shared';
import { AppNames } from '@workivate/tho-web-shared/src/analytics/types';

export const getGASectionFromUrl = (url?: string) => {
  return Analytics.getGASectionFromUrl(AppNames.Hermes, url ?? '');
};
